//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectRoomModal from '../../project/components/select-room-modal';
import VueUeditorWrap from 'vue-ueditor-wrap';
import fileUploader from '../../common-components/file-uploader';
import util from '../../../lib/util';

export default {
  name: 'reservations',
  components: {
    SelectRoomModal, VueUeditorWrap,
    fileUploader
  },
  data() {
    const vm = this;
    return {
      loading: false,
      saving: false,
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      searchInput: {},
      list: [],
      projects: [],
      columns: [
        // {
        //     type: 'selection',
        //     align: 'center',
        //     width: 60
        // },
        {
          key: 'id', title: '单号', align: 'center', minWidth: 200,
          render(h, params) {
            let row = params.row;
            let actions = [];
            let code = row.deliveryCode;
            if (code == null || code === '') {
              code = '未填写';
            }
            actions.push(
                h('a', {
                      on: {
                        click: function () {
                          vm.showDeliveryInfo(row);
                        }
                      }
                    },
                    code
                )
            );
            return actions;
          }
        },
        {
          title: '计划名称', minWidth: 99, key: 'planName', align: 'center',
          render: (h, params) => {
            let row = params.row;
            let actions = [];
            actions.push(
                h('a', {
                  on: {
                    click: function () {
                      vm.$router.push({
                        name: 'deliveryPlanInfo',
                        params: {
                          planId: row.planId
                        }
                      });
                    }
                  }
                }, row.planName));
            return actions;
          }
        },
        {
          title: '预约时间', minWidth: 110, key: '', align: 'center',
          render(h, params) {
            let row = params.row;
            let actions = [];
            let str = '';
            if (row.deliveryTimeStr) {
              str = str + row.deliveryTimeStr;
            }
            if (row.time) {
              str = str + ' ' + row.time;
            }
            // let str = row.deliveryTimeStr ? row.deliveryTimeStr : '';
            // str = str + row.time ? row.time : '';
            // const d = actions.push(h('p', str));
            return h('span', str);
          }
        },
        {
          title: '项目名称', align: 'center', key: 'projectName', minWidth: 250,
          render(h, params) {
            let row = params.row;
            let actions = [];
            actions.push(h('p', row.projectName));
            actions.push(h('p', row.roomName));
            return h('div', actions);
          }
        },
        // {
        //     title: '房间', align: 'center', key: 'roomName', minWidth: 250
        // },
        {
          key: 'name', align: 'center', title: '联系信息', minWidth: 200,
          render(h, params) {
            let row = params.row;
            let actions = [];
            actions.push(h('p', '联系人：' + (row.name ? row.name : '')));
            actions.push(h('p', '联系电话：' + (row.mobile ? row.mobile : '')));
            return h('div', actions);
          }
        },
        {
          key: 'content', align: 'center', title: '预约说明', width: 200,
          render(h, params) {
            let content = '';
            let row = params.row;
            if (row.content != null && row.content !== '') {
              if (row.content.length > 20) {
                content = row.content.substring(1, 20) + '...';
              } else {
                content = row.content;
              }
            }
            return h('Poptip', {
              props: {
                trigger: 'hover',
                // title:' 11',
                placement: 'bottom'
              }
            }, [
              h('div', content),
              h('div', {
                slot: 'content',
                style: {
                  // width: "300px",
                  // height: "100px",
                  overflow: 'hidden',
                  whiteSpace: 'normal'
                }
              }, [
                h('div', row.content)
              ])
            ]);
          }
        },
        {
          title: '资料状态', align: 'center', minWidth: 99, key: 'dataStatusStr'
        },
        {
          title: '预约状态', minWidth: 99, align: 'center', key: 'appointmentStatusStr'
        }
        // {
        //     title: '交房状态', minWidth: 99, align: 'center', key: 'deliveryStatusStr'
        // }
        // {
        //     key: 'statusStr', align: 'center', minWidth: 99,
        //     title: '状态'
        // }
        // {
        //     title: '操作',
        //     key: '',
        //     render: (h, params) => {
        //         let row = params.row;
        //         let actions = [];
        //         if (row.status == 11) {
        //             actions.push(h('Button', {
        //                 props: {
        //                     type: 'primary',
        //                     size: 'small'
        //                 },
        //                 style: {
        //                     // marginRight: '5px'
        //                 },
        //                 on: {
        //                     click: () => {
        //                          vm.dataAudit(params.row);
        //                     }
        //                 }
        //             }, '资料审核'));
        //         }
        //         return h('div', actions);
        //     }
        // }
      ],
      showDeliveryRecordEditModal: false,
      deliverRecord: {
        roomName: '',
        image: {associateType: 'DeliveryImage'}
      },
      rules: {
        projectId: [{required: true, type: 'number', message: '请选择项目', trigger: 'change'}],
        roomName: [{required: true, type: 'string', message: '请选择房间', trigger: 'blur'}],
        name: [{required: true, type: 'string', message: '请输入联系人', trigger: 'blur'}],
        mobile: [{required: true, type: 'string', message: '请输入联系电话', trigger: 'blur'}],
        deliverySource: [{required: true, type: 'number', message: '请选择来源', trigger: 'change'}],
        deliveryTime: [{required: true, type: 'date', message: '请选择预约时间', trigger: 'change'}]
      },
      showAddRoomModal: false,
      deliveryRecordCounts: {},
      label1: (h) => {
        return h('div', [
          h('span', '已预约'),
          h('Badge', {
            props: {
              count: vm.deliveryRecordCounts.tianBaoCount,
              type: 'info'
            }
          })
        ]);
      },
      label2: (h) => {
        return h('div', [
          h('span', '待安排'),
          h('Badge', {
            props: {
              count: vm.deliveryRecordCounts.xiangYingCount,
              type: 'info'
            }
          })
        ]);
      },
      label3: (h) => {
        return h('div', [
          h('span', '待反馈'),
          h('Badge', {
            props: {
              count: vm.deliveryRecordCounts.paiDanCount,
              type: 'info'
            }
          })
        ]);
      },
      label4: (h) => {
        return h('div', [
          h('span', '待评价'),
          h('Badge', {
            props: {
              count: vm.deliveryRecordCounts.chuLiCount,
              type: 'info'
            }
          })
        ]);
      },
      label5: (h) => {
        return h('div', [
          h('span', '处理完成'),
          h('Badge', {
            props: {
              count: vm.deliveryRecordCounts.wanChengCount,
              type: 'info'
            }
          })
        ]);
      },
      label6: (h) => {
        return h('div', [
          h('span', '所有'),
          h('Badge', {
            props: {
              // count: this.deliveryRecordCounts.allCount,
              type: 'info'
            }
          })
        ]);
      },
      label10: (h) => {
        return h('div', [
          h('span', '提交资料通知'),
          h('Badge', {
            props: {
              count: vm.deliveryRecordCounts.tiJiaoTongZhiCount,
              type: 'info'
            }
          })
        ]);
      },
      label11: (h) => {
        return h('div', [
          h('span', '资料已提交'),
          h('Badge', {
            props: {
              count: vm.deliveryRecordCounts.yiTiJiaoCount,
              type: 'info'
            }
          })
        ]);
      },
      label0: (h) => {
        return h('div', [
          h('span', '预约通知'),
          h('Badge', {
            props: {
              count: vm.deliveryRecordCounts.weiYuYueCount,
              type: 'info'
            }
          })
        ]);
      },
      deliveryPlans: [],
      tabName: ''
    };
  },
  methods: {
    pageChange(page) {
      this.currentPage = page;
      this.getPage();
    },
    pageSizeChange(pagesize) {
      this.pageSize = pagesize;
      this.getPage();
    },
    onGetPage(status) {
      this.tabName = status;
      if (status == 'null') {
        this.searchInput.status = '';
      } else {
        this.searchInput.status = parseInt(status);
      }
      this.getPage();
    },
    getPage() {
      this.loading = true;
      this.searchInput.maxResultCount = this.pageSize;
      this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
      abp.ajax.post('/api/services/app/DeliveryRecord/SearchDeliveryRecords', this.searchInput).then(res => {
        this.list = [];
        this.list.push(...res.data.result.items);
        this.totalCount = res.data.result.totalCount;
        // this.getCounts();
      }).finally(() => {
        this.loading = false;
      });
    },
    getProjects() {
      this.$store.dispatch({
        type: 'project/getProjects'
      }).then(() => {
        this.projects = this.$store.state.project.projects;
      });
    },
    showAddRoom() {
      this.showAddRoomModal = true;
    },
    addRoom(data) {
      console.log(data);
      this.deliverRecord.projectId = data.projectId;
      this.deliverRecord.projectName = data.project.name;
      this.deliverRecord.roomId = data.id;
      this.deliverRecord.roomName = data.projectStages + data.roomStructureName + data.chamberName + data.roomNumber;
      this.deliverRecord.name = data.name;
      this.deliverRecord.mobile = data.phoneNumber;
      this.deliverRecord.memberId = data.memberId;
      this.showAddRoomModal = false;
    },
    editDeliveryRecord(deliverRecord) {
      this.deliverRecord = deliverRecord;
      this.deliverRecord.image = {associateType: 'DeliveryImage'};
      this.saving = false;
      this.showDeliveryRecordEditModal = true;
    },
    onClear() {
      this.deliverRecord.roomId = 0;
    },
    cancel() {
      this.showDeliveryRecordEditModal = false;
    },
    onChange(d) {
      console.log(d);
      if (d) {
        this.deliverRecord.roomId = 0;
        this.deliverRecord.roomName = '';
        this.deliverRecord.projectName = d.label;
      }
    },
    onSave() {
      var vm = this;
      console.log(vm.deliverRecord);
      this.$refs.deliverRecordForm.validate(async (val) => {
        if (val) {
          vm.saving = true;
          abp.ajax.post('/api/services/app/DeliveryRecord/SaveDeliveryRecord', vm.deliverRecord).then(res => {
            vm.showDeliveryRecordEditModal = false;
            vm.getPage();
          }).finally(() => {
            vm.saving = false;
          });
        }
      });
    },
    showDeliveryInfo(row) {
      this.$router.push({
        path: '/reservationInfo/' + row.id
      });
    },
    getCounts() {
      this.loading = true;
      var params = {
        projectId: this.searchInput.projectId,
        keyName: this.searchInput.keyName,
        planId: this.searchInput.planId,
        isDataAudit: this.searchInput.isDataAudit
      };
      abp.ajax.post('/api/services/app/DeliveryRecord/DeliveryRecordCounts', params).then(res => {
        this.deliveryRecordCounts = res.data.result;
      }).finally(() => {
        this.loading = false;
      });
    },
    hasPermission(permission) {
      return abp.auth.isGranted(permission);
    },
    getPlans() {
      abp.ajax.get('/api/services/app/Delivery/GetAuditDeliveryPlanList').then(res => {
        this.deliveryPlans = [];
        this.deliveryPlans.push(...res.data.result);
      }).finally(() => {

      });
    },
    onClickedDownload() {
      // console.log(this.tabName);
      if (!this.searchInput.planId) {
        this.$Message.error('请选择一个计划');
        return;
      }
      let url = util.ApiUrl + 'file/DownloadPdfData?planId=' + this.searchInput.planId + '&status=' + this.tabName;
      if (this.searchInput.dataStatus !== undefined) {
        url = url + '&dataStatus=' + this.searchInput.dataStatus
      }
      if (this.searchInput.appointmentStatus !== undefined) {
        url = url + '&appointmentStatus=' + this.searchInput.appointmentStatus
      }
      window.open(url);
    },
    onClickedDownloadExcel() {
      if (!this.searchInput.planId) {
        this.$Message.error('请选择一个计划');
        return;
      }
      let url = util.ApiUrl + 'delivery/deliveryRecordExcel?planId=' + this.searchInput.planId + '&status=' + this.tabName;
      if (this.searchInput.dataStatus !== undefined) {
        url = url + '&dataStatus=' + this.searchInput.dataStatus
      }
      if (this.searchInput.appointmentStatus !== undefined) {
        url = url + '&appointmentStatus=' + this.searchInput.appointmentStatus
      }
      window.open(url);
    },
    isActiveChange(val) {
      console.log(val);
      if (val === 'Actived') {
        // this.filters[3].Value = true;
        this.searchInput.isDataAudit = true;
      } else if (val === 'NoActive') {
        // this.filters[3].Value = false;
        this.searchInput.isDataAudit = false;
      } else {
        // this.filters[3].Value = null;
        this.searchInput.isDataAudit = null;
      }
    },
    onReset() {
      this.searchInput = {};
      this.pageChange(1);
    }
  },
  created() {
    this.getPage();
    this.getProjects();
    this.getPlans();
  }
};
